import Button from "../../components/button";
import Header from "./header";
import { t } from "i18next";
import Visa from "../../assets/images/visa.png"
import ArrowUp from "../../assets/icons/arrow-up.png"
import Div from "../../assets/images/div.png";
import Div_1 from "../../assets/images/div-1.png";
import Div_2 from "../../assets/images/div-2.png";
import GiftCard from "../../assets/images/image1.png";
import { ReactComponent as Support } from "../../assets/icons/support.svg";
import { ReactComponent as SupportedCards } from "../../assets/icons/supported-cards.svg";
import { ReactComponent as LeadingRates } from "../../assets/icons/leading-rates.svg";
import { ReactComponent as Notififications } from "../../assets/icons/instant-notifications.svg";
import { ReactComponent as Logo } from "../../assets/images/Logo-secondary.svg";
import { ReactComponent as Insta } from "../../assets/icons/Instagram.svg";
import { ReactComponent as Facebook } from "../../assets/icons/Facebook.svg";
import { ReactComponent as Twitter } from "../../assets/icons/Twitter.svg";
import {useRef} from 'react';
import { useSearchParams } from "react-router-dom";


import * as Yup from "yup";
import { useEffect, useState } from "react";
import ContactUs from "../../components/contact/contactUs";
import { Link } from "react-router-dom";


const HomeScreen = () => {
    const ref = useRef(null);
    let [searchParams, setSearchParams] = useSearchParams();

    useEffect(()=> {
       let element=  searchParams.get('tab');
       if(element=='contactUs') {
        ref.current?.scrollIntoView({behavior: 'smooth', block: "end", inline: "nearest"});
       }
        console.log("@@@")
        // let element= document.getElementById('contactUs');
       
        // element.scrollIntoView({behavior:"smooth", off})
    },[])

    return (
        <div>
            {/* <Navigation /> */}
            {/* <Header /> */}
            <div className="flex flex-col gap-8 ">


                <section className="home-container ">
                    <div className='content  xs:!h-auto md:!h-auto xs:gap-16 md:gap-16 lg:justify-between xs:!pt-[120px] sm:!pt-[120px] md:!pt-[120px] lg:!h-screen sm:!pb-[120px]'>
                        <div className="flex flex-col items-start gap-8 w-full">
                            <h1 className="text-white text-6xl xs:text-4xl w-10/12 sm:w-full xs:w-full text-left font-semibold">Get the most out of your giftcards</h1>
                            <p className="text-white text-xl text-left">Find out why thousands of vizion enthusiasts trust us to provide the most value for their giftcards</p>
                            <Button
                                className="block  w-auto bg-blue"
                                // loading={isLoading}
                                type="submit"
                            >
                                {t("Start earning today")}
                            </Button>
                        </div>

                        <div className="w-full">
                            <img className="w-[80%]  sm:mx-auto md:mx-auto lg:ml-auto" src={Visa} alt="" />
                        </div>
                    </div>
                </section>

                <section className="flex md:flex-col lg:flex-row  xs:flex-col  justify-between items-center gap-16 xs:gap-8 px-16 xs:px-4 py-12 xs:py-6">
                    <h1 className=" text-9xl xs:text-4xl xs:font-semibold text-black w-full">Effortless sign up</h1>
                    <div className="space-y-4 w-full">
                        <p className="text-black text-xl">Whether you have a bunch of gift cards you want combine for a single purchase or a single card you just haven't gotten around to using</p>
                        <Button
                            className="block  w-auto bg-blue"
                            // loading={isLoading}
                            type="submit"
                        >
                            {t("Start earning today")}
                        </Button>
                    </div>
                </section>

                <hr className="w-full border-gray-300 opacity-25 border-solid px-16" />
                <section className="flex justify-between xs:flex-col items-center gap-16 px-16 xs:px-4 py-12 xs:py-6">
                    <div className="flex flex-col items-start gap-3 w-full xs:w-full">
                        <p className=" text-base text-black ">Step 1 </p>
                        <div className="flex  items-center gap-3">
                            <h5 className=" text-6xl text-black">Sign up</h5>
                            <img className="w-[60px] h-[60px]" src={ArrowUp} alt="" />
                        </div>
                        <p className=" text-base text-black ">Register in minutes </p>
                    </div>

                    <div className="w-full h-auto">
                        <img className="sm:w-full w-full md:ml-auto " src={Div} alt="" />
                    </div>

                </section>
                <hr className="w-full border-gray-300 opacity-25 border-solid px-16" />
                <section className="flex justify-between xs:flex-col items-center gap-16 px-16 xs:px-4 py-12 xs:py-6">
                    <div className="flex flex-col items-start gap-3 w-full xs:w-full">
                        <p className=" text-base text-black ">Step 2 </p>
                        <div className="flex  items-center gap-3">
                            <h5 className=" text-6xl text-black">Photos</h5>
                            <img className="w-[60px] h-[60px]" src={ArrowUp} alt="" />
                        </div>
                        <p className=" text-base text-black ">Drag a file from your computer or snap a photo from your phone </p>
                    </div>

                    <div className="w-full h-auto">
                        <img className="sm:w-full w-full md:ml-auto" src={Div_1} alt="" />
                    </div>

                </section>
                <hr className="w-full border-gray-300 opacity-25 border-solid px-16" />
                <section className="flex justify-between xs:flex-col items-center gap-16 px-16 xs:px-4 py-12 xs:py-6">
                    <div className="flex flex-col items-start gap-3 w-full xs:w-full">
                        <p className=" text-base text-black ">Step 3 </p>
                        <div className="flex  items-center gap-3">
                            <h5 className=" text-6xl text-black">Created</h5>
                            <img className="w-[60px] h-[60px]" src={ArrowUp} alt="" />
                        </div>
                        <p className=" text-base text-black ">Our reviewers work around the clock to verify card balances and process customer payouts. </p>
                    </div>

                    <div className="w-full h-auto">
                        <img className="sm:w-full w-full md:ml-auto " src={Div_2} alt="" />
                    </div>

                </section>

                <section className="home-container !bg-banner-secondary !h-auto">
                    {/* <div className='content px-4'> */}
                    <div className="flex flex-col items-center gap-8 px-16 xs:px-4 py-12 xs:py-6">
                        <h5 className="text-[87px] xs:text-4xl xs:font-semibold text-black !leading-normal">Free your gift cards</h5>
                        <p className=" text-xl text-black !leading-normal">Whether you have a bunch of gift cards you want combine for a single purchase or a single card you just haven't gotten around to using</p>
                        <img className="w-full md:w-auto md:mx-auto h-auto xs:h-auto mt-5" src={GiftCard} alt="" />
                    </div>
                    {/* </div> */}
                </section>

                <section className="home-container !bg-banner-tertiary !h-auto ">
                    <div className="px-16 xs:px-4 py-40 xs:py-16 space-y-16">


                        <div className="flex flex-row xs:flex-col md:flex-col lg:flex-row items-start justify-between gap-8 ">
                            <h5 className="text-[87px] xs:text-4xl xs:font-semibold text-white !leading-none">The best cash-back rates around</h5>
                            <p className=" text-xl text-lightGrey !leading-normal pt-6">- First time customers start as high as 89% cash-back on Visa and Mastercard gift cards, and it only goes up from there.</p>
                            {/* <img className="w-full h-full mt-5" src={GiftCard} alt="" /> */}
                        </div>

                        <div className="grid grid-cols-2 xs:grid-cols-1 gap-12">
                            <div className="flex gap-4 items-center">
                                <div className="w-[100px]">
                                    <Support className="w-[90px]" />
                                </div>
                                <div className="space-y-3">
                                    <p className=" text-3xl text-white ">24/7 Support</p>
                                    <p className="text-base text-lightGrey ">Our growing network of cards includes Visa, Mastercard, AMEX, and gift cards, with members of our team working tirelessly to expand our network.</p>
                                </div>
                            </div>
                            <div className="flex gap-4 items-center">
                                <div className="w-[100px]">
                                    <SupportedCards className="w-[90px]" />
                                </div>
                                <div className="space-y-3">


                                    <p className=" text-3xl text-white ">Many supported cards</p>
                                    <p className="text-base text-lightGrey ">Get notified the moment your funds are on their way</p>
                                </div>
                            </div>
                            <div className="flex gap-4 items-center">
                                <div className="w-[100px]">
                                    <LeadingRates className="w-[90px]" />
                                </div>
                                <div className="space-y-3">


                                    <p className=" text-3xl text-white ">Industry leading rates</p>
                                    <p className="text-base text-lightGrey ">Get notified the moment your funds are on their way</p>
                                </div>
                            </div>
                            <div className="flex gap-4 items-center">
                                <div className="w-[100px]">
                                    <Notififications className="w-[90px]" />
                                </div>
                                <div className="space-y-3">


                                    <p className=" text-3xl text-white ">Instant notifications</p>
                                    <p className="text-base text-lightGrey ">Stay informed instantly with our cutting-edge notification system, delivering real-time updates right to your fingertips.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

            </div>

                <div ref={ref} id="contactUs" >
            <ContactUs />
            </div>

          


        </div>
    )
}

export default HomeScreen;